<template>
  <div class="form-group">
    <input
      v-bind="$attrs"
      @input="$emit('input', $event.target.value)"
      v-bind:value="value"
      type="number"
      class="form-control"
      id="number"
      step="0"
    />
  </div>
</template>

<script>
export default {
  name: "IntegerComponent",
  inheritAttrs: false,
  props: {
    label: String,
    name: String,
    value: [String, Boolean, Array, Object, Number],
  },
};
</script>

<style>
</style>